import { DragEndEvent } from '@dnd-kit/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
// import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';


import { currentBranding } from '../../../config/branding';
import { DevicePointsInterface } from '../../../interface/device-management.interface';
import CustomRadioButton from '../../../shared-components/custom-radio-button/CustomRadioButton';
import {CapitalizeFirstLetter} from '../../../shared-functions/StringFunctions';

// import DraggablePriority from './DraggablePriority';

interface ChargePointComponentProperties {
  singlePriority: DevicePointsInterface;
  handleAvailabilityChange: (id: string, value: string) => void;
  handleDragEnd?: (id: string, event: DragEndEvent) => void;
}

/**
 * Component to change point availability and priorities
 */
function ChargePoint(properties: ChargePointComponentProperties) {
  const { t } = useTranslation("scheduleManagement");
  const { singlePriority, handleAvailabilityChange } = properties;

  /**
   * Function to add point with drag & drop event
   * @param event
   */
  // const handleDragEndWithPointId = (event: DragEndEvent) => {
  //   handleDragEnd(singlePriority.connectorId, event);
  // };

  return (
    <div className="charge-point-wrap">
      <div className={`title-content ${currentBranding}`}>
        {CapitalizeFirstLetter(singlePriority.connector)}
      </div>
      <div className="charge-point-status-wrap">
        <CustomRadioButton
          name={singlePriority.connector}
          value="available"
          label={t("available")}
          selected={singlePriority.isReservationEnabled}
          onChangeFunc={handleAvailabilityChange}
        />
        <CustomRadioButton
          name={singlePriority.connector}
          value="unavailable"
          label={t("unavailable")}
          selected={!singlePriority.isReservationEnabled}
          onChangeFunc={handleAvailabilityChange}
        />
      </div>
      {/* <div className="charge-point-priority-wrap">
        <DndContext onDragEnd={handleDragEndWithPointId}>
          <div className="charge-point-priority-container">
            <SortableContext items={singlePriority.priority} strategy={verticalListSortingStrategy}>
              {singlePriority.priority.map((priority) => (
                <DraggablePriority id={priority.id} title={priority.title} key={priority.id} />
              ))}
            </SortableContext>
          </div>
        </DndContext>
      </div> */}
    </div>
  );
}

export default ChargePoint;
